export class SelfImpersonationError extends Error {
    constructor() {
        super(`It's not allowed to impersonate yourselves during another impersonation session`);

        Object.setPrototypeOf(this, SelfImpersonationError.prototype);
    }
}
